import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoggerService } from '@app/core/services/logger.service';
import { HomepagePage } from '@app/modules/home/pages/homepage/homepage.page';
const logger = new LoggerService('CounterLessAddComponent');

@Component({
  selector: 'dhl-counter-less-add',
  templateUrl: './counter-less-add.component.html',
  styleUrls: ['./counter-less-add.component.scss']
})
export class CounterLessAddComponent implements OnInit {
  @Input() identificador!: string;
  @Input() nombre!: string;
  @Input() valueEntry!: string;
  @Input() maxValue!: number;
  @Input() minValue: number = 1;

  @Output() executeMethodForPathern = new EventEmitter<boolean>();

  isZero!: boolean;
  isMax: boolean = false;

  valueInp!: string;

  constructor(public home: HomepagePage, private readonly snackBar: MatSnackBar) {}

  ngOnInit(): void {
    logger.info('Init counter');
  }

  decrementToOne(event: MouseEvent, identificador: string) {
    logger.info(event);
    const input = document.getElementById(`${identificador}id`) as HTMLInputElement;
    input.value = (parseInt(input.value, 10) - 1).toString();

    if (Number(input.value) >= this.maxValue) {
      this.isMax = true;
    } else if (Number(input.value) <= this.minValue) {
      this.isMax = false;
      this.isZero = true;
    } else {
      this.isMax = false;
    }

    if (parseInt(input.value, 10) > this.minValue) {
      this.valueInp = input.value;
      this.isZero = false;
    } else if (parseInt(input.value, 10) < this.minValue) {
      this.valueInp = input.value;
      input.value = this.minValue.toString();
      this.isZero = true;
      input.value = this.minValue.toString();
      this.snackBar.open(`El número mínimo de guías individuales que puede comprar es ${this.minValue}`);
    }

    this.emitirValorAInput(input.value);
    this.executeActionPathern();
  }

  getValue(): string {
    const input = document.getElementById(this.identificador) as HTMLInputElement;
    return input.value;
  }

  incrementToOne(event: MouseEvent, identificador: string) {
    logger.info(event);
    const input = document.getElementById(`${identificador}id`) as HTMLInputElement;
    if (Number(input.value) >= this.maxValue) {
      input.value = this.maxValue.toString();
      this.isMax = true;
    } else {
      input.value = (parseInt(input.value, 10) + 1).toString();
      this.isMax = false;
    }
    this.isZero = false;
    this.emitirValorAInput(input.value);
    this.executeActionPathern();
  }

  emitirValorAInput(value: any) {
    const searchRegExp = /%/g;
    const ident = this.nombre.split(' ').join('').replace(searchRegExp, '');
    this.home.cambiarValorInput(`#${ident}`, value);
  }

  valueChanged(event: any, identificador: string) {
    logger.info(event);
    const input = document.getElementById(`${identificador}id`) as HTMLInputElement;
    if (Number(input.value) > this.maxValue) {
      input.value = this.maxValue.toString();
      this.isMax = true;
    } else if (Number(input.value) < this.minValue) {
      input.value = this.minValue.toString();
      this.isZero = true;
      this.snackBar.open(`El número mínimo de guías individuales que puede comprar es ${this.minValue}`);
    } else {
      input.value = parseInt(input.value, 10).toString();
      this.isMax = false;
    }

    this.isZero = false;
    this.emitirValorAInput(input.value);
    this.executeActionPathern();
  }

  resetInput() {
    const input = document.getElementById(`${this.identificador}id`) as HTMLInputElement;
    input.value = this.minValue.toString();
  }

  resetInput3() {
    const input = document.getElementById(`${this.identificador}id`) as HTMLInputElement;
    input.value = this.minValue.toString();
    this.isZero = true;
    this.isMax = false;
  }

  executeActionPathern() {
    this.executeMethodForPathern.emit(true);
  }
}
